interface IFilterValues {
  type?: string;
  status?: string;
  developerCompany?: string;
  issuedOn?: string;
  issuedOff?: string;
  [key: string]: any;
}

const generateFilter = (values: IFilterValues): string =>
  Object.keys(values)
    .filter((el) => !!values[el])
    .map((el) => {
      switch (el) {
        case "type":
        case "status":
        case "developerCompany":
          return `${el}=${values[el]}`;
        case "issuedOn":
          if (!values.issuedOff) {
            return `${el}>=${values[el]}, issuedOn<=${values[el]}`;
          }
          return `${el}>=${values[el]}`;
        case "issuedOff":
          return `issuedOn<=${values[el]}`;
        default:
          return el;
      }
    })
    .join(",");

export default generateFilter;
